import Component from 'flarum/common/Component';

/**
 * Tiny Markdown renderer.
 *
 * Flarum's `flarum/common/components/Markdown` does not exist in every
 * version of core (and certainly not in this installation), so we render
 * directly using the bundled `s9e.TextFormatter` global — the same engine
 * the core ComposerPostPreview uses for its live preview.
 *
 * Usage:
 *   <Markdown text="**hello** world" />
 */
export default class Markdown extends Component {
  oncreate(vnode) {
    this.renderTo(vnode.dom);
  }

  onupdate(vnode) {
    this.renderTo(vnode.dom);
  }

  renderTo(dom) {
    const text = this.attrs.text || '';
    if (typeof s9e !== 'undefined' && s9e.TextFormatter && typeof s9e.TextFormatter.preview === 'function') {
      // Flarum's bundled markdown engine. Preview is synchronous and
      // mutates the given DOM element in place.
      s9e.TextFormatter.preview(text, dom);
    } else {
      // Hard fallback: render the raw text as a text node. Better than
      // a thrown error that breaks the surrounding poststream.
      dom.textContent = text;
    }
  }

  view() {
    return <div className="TaroMarkdown" />;
  }
}
